// extracted by mini-css-extract-plugin
module.exports = {"answer":"AnswersModal_answer__3DKdj","content":"AnswersModal_content__3cM1b","list":"AnswersModal_list__2YKnD"};